import styles from "../../styles/Components/layout/AuthLayout.module.css";

function AuthLayout({ children }) {
  return (
    <div className={styles.container}>
      <div className={styles.imgContainer}></div>
      <div className={styles.authContent}>
        <a className={styles.siteLink} href="https://cryptocrispy.com.au/">
          CryptoCrispy
        </a>
        {children}
      </div>
    </div>
  );
}

export default AuthLayout;
